import Symbol from './Symbol';
import { bonusLabels, jackpotLabels } from '../fontStyles';
import MoneyFormat from 'Engine/base/moneyFormat/MoneyFormat';
import EntryPoint from 'Engine/EntryPoint';
import eSymbolIndex from './eSymbolIndex';

export default class BonusSymbol extends Symbol {
  constructor(...args) {
    super(...args);
  }

  init() {
    super.init();
    this._label = this.getChildByName('label');
    this.valueTextField = this.label.getChildByName('value');
    this.valueTextField.correctPosition('center', 'center');
    this.onAnimationComplete = this._onAnimationComplete.bind(this);
    // this.valueTextField.style = { ...this.valueTextField.style, ...jackpotSymbolLabelFontStyle };
    // this.jackpotLabel = this.label.getChildByName('jackpotLabels');
    // this.jackpotLabel.visible = false;
  }

  changeSymbol(id, reel) {
    this.id = id;
    this.stopAnimation();

    if (id === 0) {
      this.goToFrame(this.frameIndexes.EMPTY);
      // this.image = null;
      this.label.visible = false;
      return;
    }

    this.animationSymbol.id = this.symbolIdsRelations[this.symbolFrames[id]];
    // this.goToFrame(this._blurred ? this.frameIndexes.blurred : this.frameIndexes.symbol);
    this.goToFrame(this.symbolFrames[id]);
    this.setValue(EntryPoint.GameModel.getBonusLabel(id));
    this.image = this.getChildAt(0);
  }

  startStopAnimation() {
    if (this.currentFrameIndex === this.frameIndexes.EMPTY) return;
    super.startStopAnimation();
  }

  startIdleAnimation() {
    if (this.currentFrameIndex === this.frameIndexes.EMPTY) return;
    this.image = this.getChildAt(0);
    this.image.visible = false;
    this.animationSymbol.startIdleAnimation();
  }

  stopAnimation() {
    if (this.currentFrameIndex === this.frameIndexes.EMPTY) return;
    this.image.visible = true;
    this.animationSymbol.stop();
  }

  setValue(value) {
    if (this.currentFrameIndex === this.frameIndexes.EMPTY) return;
    if (parseFloat(value)) {
      this.valueTextField.text = MoneyFormat.format(value, false);
      this.valueTextField.style = { ...this.valueTextField.style, ...bonusLabels };
    } else {
      this.valueTextField.text = value;
      this.valueTextField.style = { ...this.valueTextField.style, ...jackpotLabels };
    }

    this.label.visible = this.currentFrameIndex === this.frameIndexes.BONUS;
  }

  _onAnimationComplete() {
    this.emit('animationComplete', this);
  }

  set blur(value) {
    // this._blurred = value;
    // this.changeSymbol(this.id);
  }

  get label() {
    return this._label;
  }

  get symbolIdsRelations() {
    if (!this._symbolIdsRelations) {
      this._symbolIdsRelations = {
        [this.frameIndexes.EMPTY]: null,
        [this.frameIndexes.BONUS]: eSymbolIndex.ESI_BONUS,
        [this.frameIndexes.MINI]: eSymbolIndex.ESI_BONUS_MINI,
        [this.frameIndexes.MAJOR]: eSymbolIndex.ESI_BONUS_MAJOR,
        [this.frameIndexes.GRAND]: eSymbolIndex.ESI_BONUS_GRAND,
      };
    }
    return this._symbolIdsRelations;
  }

  get symbolFrames() {
    if (!this._symbolFrames) {
      let frames = [this.frameIndexes.BONUS, this.frameIndexes.MINI, this.frameIndexes.MAJOR, this.frameIndexes.GRAND];
      let index = 0;
      this._symbolFrames = EntryPoint.GameModel.availableBonusSymbolIds.reduce((res, coeff, i, arr) => {
        if (i >= arr.length - EntryPoint.GameModel.jackpotCoeffs.length) index++;
        res[coeff] = frames[index];
        return res;
      }, {});
    }

    return this._symbolFrames;
  }

  get frameIndexes() {
    if (!this._frameIndexes) {
      this._frameIndexes = {
        EMPTY: 1,
        BONUS: 2,
        MINI: 3,
        MAJOR: 4,
        GRAND: 5,
      };
    }

    return this._frameIndexes;
  };
}
